import { BORDER_RADIUS, BREAKPOINTS } from '@app/style/constants';
import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex)`
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0 16px;

    &.content-wrapper {
        background-color: var(--grayUltraLight);
        border-radius: ${BORDER_RADIUS};
        padding-top: 16px;
        padding-bottom: 16px;
    }

    @media (min-width: ${BREAKPOINTS.xs}px) {
            //max-width: ${BREAKPOINTS.xs}px;
        max-width: 100%;
    }

    @media (min-width: ${BREAKPOINTS.sm}px) {
        max-width: ${BREAKPOINTS.sm}px;
    }

    @media (min-width: ${BREAKPOINTS.md}px) {
        max-width: ${BREAKPOINTS.md}px;
    }

    @media (min-width: ${BREAKPOINTS.lg}px) {
        max-width: ${BREAKPOINTS.lg}px;
    }

    @media (min-width: ${BREAKPOINTS.xl}px) {
        max-width: ${BREAKPOINTS.xl}px;
    }

    @media (min-width: 1536px) {
        max-width: 1536px;
    }
`;
